// components/auth/LogoutButton.tsx
'use client'

import { signOut } from 'next-auth/react'
import { SeericButton } from '@/app/components/SeericButton/SeericButton'
import { LogOut } from 'lucide-react'

export default function LogoutButton() {
  const handleSignOut = () => {
    signOut({ callbackUrl: '/signin' })

  }

  return (
    <SeericButton
      onClick={handleSignOut}
      variant="danger"
      className="flex items-center gap-2 w-full h-12"
    >
      <LogOut size={16} />
      Se déconnecter
    </SeericButton>
  )
}
